import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { SourcePowerBIEnum } from 'src/app/interfaces/models/filter-item.model';
import { FiltersGeneralDashboardModel } from 'src/app/interfaces/models/filters-general-dashboard.model';
import { IPBITokenInfoResponse } from 'src/app/interfaces/Responses/IPBITokenInfoResponse';
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  url: string = environment.urlBaseService
  urlPBITokenInfo = `${this.url}PBITokenInfo`
  urlExportStream = `${this.url}ExportInfo`

  constructor(private httpClient: HttpClient) { }

  getPBITokenInfo(siteId: string, reportId: string, dashboardTypeId: string, businessUnitId: string): Observable<IPBITokenInfoResponse> {
    return this.httpClient.get<IPBITokenInfoResponse>(`${this.urlPBITokenInfo}?SITE_ID=${siteId}&REPORTID=${reportId}&dashboardTypeId=${dashboardTypeId}&businessUnitId=${businessUnitId}`)
  }

 

  getExportStream(siteId: string, dashboardConfigId: string, format: string, dashboardTypeId: string, businessUnitId: string, filters: FiltersGeneralDashboardModel, source: SourcePowerBIEnum): Observable<Blob> {
    const urlExportStream = `${this.urlExportStream}?SITE_ID=${siteId}&DASHBOARD_CONFIG_ID=${dashboardConfigId}&EXPORT_TYPE=${format}&dashboardTypeId=${dashboardTypeId}&businessUnitId=${businessUnitId}&filters=${JSON.stringify(filters)}&Source=${source}`
    return this.httpClient.get(urlExportStream,
      { responseType: 'blob' }
    ).pipe(map(response => response)) as Observable<Blob>;
  }
}
